import React from "react";

import PreviewImage from "./Preview";
import PlaceholderImage from "./Placeholder";
import { observer } from "mobx-react-lite";

interface ImageProps {
  initialImageUri?: string;
  uploadImageUri?: string;
  placeholderImage?: React.FunctionComponent;
}

export default observer(function Image({
  initialImageUri,
  placeholderImage,
  uploadImageUri,
}: ImageProps) {
  if (!uploadImageUri)
    return initialImageUri ? (
      <PreviewImage image={initialImageUri} />
    ) : (
      <PlaceholderImage image={placeholderImage} />
    );

  return <PreviewImage image={uploadImageUri} />;
});
